import React from "react";

import image1 from './images/SomeTime/SOME_TIME_00022 Large.jpeg';
import image2 from './images/SomeTime/SOME_TIME_00023 Large.jpeg';
import image3 from './images/SomeTime/SOME_TIME_00024 Large.jpeg';
import image4 from './images/SomeTime/SOME_TIME_00025 Large.jpeg';
import image5 from './images/SomeTime/SOME_TIME_00026 Large.jpeg';
import image6 from './images/SomeTime/SOME_TIME_00027 Large.jpeg';
import image7 from './images/SomeTime/SOME_TIME_00028 Large.jpeg';
import image8 from './images/SomeTime/SOME_TIME_00029 Large.jpeg';
import image9 from './images/SomeTime/SOME_TIME_00030 Large.jpeg';
import image10 from './images/SomeTime/SOME_TIME_00031 Large.jpeg';
import image11 from './images/SomeTime/SOME_TIME_00032 Large.jpeg';
import image12 from './images/SomeTime/SOME_TIME_00033 Large.jpeg';
import image13 from './images/SomeTime/SOME_TIME_00034 Large.jpeg';
import image14 from './images/SomeTime/SOME_TIME_00035 Large.jpeg';
import image15 from './images/SomeTime/SOME_TIME_00036 Large.jpeg';
import image16 from './images/SomeTime/SOME_TIME_00037 Large.jpeg';
import image17 from './images/SomeTime/SOME_TIME_00038 Large.jpeg';
import image18 from './images/SomeTime/SOME_TIME_00039 Large.jpeg';
import image19 from './images/SomeTime/SOME_TIME_00040 Large.jpeg';
import image20 from './images/SomeTime/SOME_TIME_00041 Large.jpeg';
import image21 from './images/SomeTime/SOME_TIME_00042 Large.jpeg';
import image22 from './images/SomeTime/SOME_TIME_00043 Large.jpeg';
import image23 from './images/SomeTime/SOME_TIME_00044 Large.jpeg';
import image24 from './images/SomeTime/SOME_TIME_00045 Large.jpeg';
import image25 from './images/SomeTime/SOME_TIME_00046 Large.jpeg';

const SomeTime = () => {
    return (
    <div className="picture-gallery">
        <div className="photo-column">
            <div className="single">
                <img src={image1}/>
            </div>
            <div className="single">
                <img src={image2}/>
            </div>
            <div className="single">
                <img src={image3}/>
            </div>
            <div className="single">
                <img src={image4}/>
            </div>
            <div className="single">
                <img src={image5}/>
            </div>
            <div className="single">
                <img src={image6}/>
            </div>
            <div className="single">
                <img src={image7}/>
            </div>
            <div className="single">
                <img src={image8}/>
            </div>
            <div className="single">
                <img src={image9}/>
            </div>
            <div className="single">
                <img src={image10}/>
            </div>
            <div className="single">
                <img src={image11}/>
            </div>
            <div className="single">
                <img src={image12}/>
            </div>
            <div className="single">
                <img src={image13}/>
            </div>
            <div className="single">
                <img src={image14}/>
            </div>
            <div className="single">
                <img src={image15}/>
            </div>
            <div className="single">
                <img src={image16}/>
            </div>
            <div className="single">
                <img src={image17}/>
            </div>
            <div className="single">
                <img src={image18}/>
            </div>
            <div className="single">
                <img src={image19}/>
            </div>
            <div className="single">
                <img src={image20}/>
            </div>
            <div className="single">
                <img src={image21}/>
            </div>
            <div className="single">
                <img src={image22}/>
            </div>
            <div className="single">
                <img src={image23}/>
            </div>
            <div className="single">
                <img src={image24}/>
            </div>
            <div className="single">
                <img src={image25}/>
            </div>
        </div>
    </div>
    );
}

export default SomeTime;